import { useMemo, useCallback, useRef } from 'react';
import { useIntl } from 'react-intl';

import { useToastNotificationContext } from '../global/alert/useToastNotification';

const encryptionWorker = new ComlinkWorker<
  typeof import('./worker/encryptionWorker')
>(new URL('./worker/encryptionWorker', import.meta.url), {
  name: 'encryptionWorker',
  type: 'module',
});

const useEncryption = () => {
  const intl = useIntl();
  const { createToastNotification } = useToastNotificationContext();
  const encryptionFailed = useRef(false);

  const workerInstance = useMemo(() => {
    const worker = encryptionWorker;
    return worker;
  }, []);

  const encryptText = useCallback(
    async (text: string) => {
      if (!text) {
        if (!encryptionFailed.current) {
          createToastNotification(intl.formatMessage({ defaultMessage: 'Encrypytion error!' }), 'error');
        }
        return '';
      }
      const processedText = await workerInstance.encryptText(text);
      encryptionFailed.current = false;
      return processedText;
    },
    [createToastNotification, intl, workerInstance],
  );

  return { encryptText }; // Return the encryptText function
};

export default useEncryption; // Export the custom hook
